import { render } from "./StatsItemComponent.vue?vue&type=template&id=7b5341a2"
import script from "./StatsItemComponent.vue?vue&type=script&lang=js"
export * from "./StatsItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__